/**
 * React Router Configuration
 * Modular routing with lazy loading for better performance
 *
 * Route modules are organized by feature domain:
 * - auth: Login, password reset, public routes
 * - admin: Dashboard, users, settings
 * - platform: Super user platform administration
 * - students: Students, families, guardians
 * - classes: Classes, campuses, enrollments, applications
 * - billing: Fees, invoices, payments, discounts, statements
 * - operations: Attendance, hifdh, calendar, notifications, timecard
 * - reports: Analytics and reports
 * - portals: Parent and teacher portals
 */

import { createBrowserRouter, RouteObject } from "react-router-dom";
import {
  authRoutes,
  adminRoutes,
  platformRoutes,
  studentRoutes,
  teacherRoutes,
  classRoutes,
  billingRoutes,
  campaignRoutes,
  potluckRoutes,
  operationsRoutes,
  reportRoutes,
  parentPortalRoutes,
  teacherPortalRoutes,
  helpRoutes,
} from "./routes/modules";
import { NotFoundPage } from "@/pages/auth/NotFoundPage";

// 404 Not Found page
const notFoundRoute: RouteObject = {
  path: "*",
  element: <NotFoundPage />,
};

// Combine all route modules
const allRoutes: RouteObject[] = [
  // Public/Auth routes first
  ...authRoutes,

  // Admin routes
  ...adminRoutes,

  // Platform admin routes
  ...platformRoutes,

  // Core feature routes
  ...studentRoutes,
  ...teacherRoutes,
  ...classRoutes,
  ...billingRoutes,
  ...campaignRoutes,
  ...potluckRoutes,
  ...operationsRoutes,
  ...reportRoutes,

  // Portal routes
  ...parentPortalRoutes,
  ...teacherPortalRoutes,

  // Help center
  ...helpRoutes,

  // 404 catch-all last
  notFoundRoute,
];

export const router = createBrowserRouter(allRoutes, {});
